import { t } from '../../utils/i18n';
import { HOW_IT_WORKS_PHOTOS } from './constants';

const STEPS = [
  { step: 1, key: 'step1', photo: HOW_IT_WORKS_PHOTOS.search },
  { step: 2, key: 'step2', photo: HOW_IT_WORKS_PHOTOS.contact },
  { step: 3, key: 'step3', photo: HOW_IT_WORKS_PHOTOS.start },
];

export default function HowItWorks() {
  return (
    <section className="landing-section landing-section--how">
      <div className="landing-container">
        <header className="landing-section-header">
          <h2 className="landing-section-title">
            {t('landing.howItWorks.title')}
          </h2>
          <p className="landing-section-subtitle mx-auto">
            {t('landing.howItWorks.subtitle')}
          </p>
        </header>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 lg:gap-6">
          {STEPS.map((s) => (
            <article key={s.step} className="landing-step-card group flex flex-col h-full">
              <div className="relative aspect-[4/3] overflow-hidden flex-shrink-0">
                <img
                  src={s.photo.src}
                  alt={s.photo.alt}
                  className="w-full h-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.02]"
                  loading="lazy"
                  referrerPolicy="no-referrer"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/25 via-transparent to-transparent pointer-events-none" aria-hidden="true" />
                <span className="landing-step-badge absolute top-4 left-4" aria-hidden="true">
                  {s.step}
                </span>
              </div>
              <div className="landing-step-body flex flex-col flex-1">
                <h3 className="text-[17px] font-semibold text-[var(--color-text)] mb-2 leading-snug">
                  {t(`landing.howItWorks.${s.key}.title`)}
                </h3>
                <p className="text-[15px] text-[var(--color-text-muted)] leading-relaxed flex-1">
                  {t(`landing.howItWorks.${s.key}.desc`)}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
